<template>
  <el-container>
    <!--头部-->
    <el-header style="background: white">
      <div class="dis-flex js-center head wp-100">
        <div class="js-between main-width">
          <el-menu
            :default-active="activeIndex"
            text-color="#333333"
            class="el-menu-demo"
            mode="horizontal"
            @select="menuSelect"
          >
            <el-menu-item index="/countyControl/index">
              <div style="color: #2B68E4;">平台首页</div>
              <!--              <img width="150px" src="./assets/image/index/index_icon@3x.png" />-->
            </el-menu-item>
            <el-menu-item
              v-for="item in singleList"
              :key="item.url"
              :index="item.url"
            >
              <div>{{ item.name }}</div>
            </el-menu-item>
            <el-submenu
              v-for="item in doubleList"
              :key="item.url"
              :index="doubleList.indexOf(item).toString()"
            >
              <template slot="title">{{ item.name }}</template>
              <el-menu-item
                v-for="children in item.children"
                :key="children.url"
                :index="children.url"
              >
                <div class="menu-list">{{ children.name }}</div>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
        <el-dropdown v-if="userInfo">
          <div class="account-space">你好！{{ userInfo.xm }}</div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="userInfo.yhqx==='5'" @click.native="setMenu">菜单设置</el-dropdown-item>
            <el-dropdown-item @click.native="changeAccountAndPwd">修改密码</el-dropdown-item>
            <el-dropdown-item @click.native="exitSystem">退出系统</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <!--主体-->
    <el-main
      style="padding: 20px 0 0 0;"
      :class="
                $route.path != '/countyControl/index' &&
                $route.path != '/countyControl/prefectureScreen'
                    ? 'dis-flex js-center head wp-100'
                    : ''
            "
    >
      <div :class="
                    $route.path != '/countyControl/index' &&
                    $route.path != '/countyControl/prefectureScreen'
                        ? 'js-between main-width'
                        : ''
                ">
        <router-view></router-view>
      </div>
    </el-main>
    <el-footer>{{ footer }}</el-footer>
    <el-dialog
      title="菜单设置"
      :visible.sync="menuVisible"
      width="400px"
      style="text-align: center;"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <el-row class="margin-top-10" style="text-align: left; margin-left: 20px; margin-bottom: 20px;">
        <label>角色：</label>
        <el-select v-model="selectYhlx"
                   :size="GLOBAL.config.systemSize"
                   placeholder="角色"
                   clearable
                   @change="changeindex"
        >
          <el-option label="系统管理员" value="5" key="5"></el-option>
          <el-option label="县级管理员" value="3" key="3"></el-option>
          <el-option label="镇级管理员" value="4" key="4"></el-option>
        </el-select>
      </el-row>
      <el-tree
        :data="allMenu"
        show-checkbox
        node-key="uuid"
        ref="tree"
        highlight-current
        :props="defaultProps"

        @check="nodeClick"
      >
      </el-tree>
      <el-row class="margin-top-20">
        <el-button
          @click="closeMenuDialog"
          style="margin: 0 20px;"
          :size="GLOBAL.config.systemSize"
        >关闭</el-button>
        <el-button
          type="primary"
          @click="saveMenuSelect"
          style="margin: 0 20px;"
          :size="GLOBAL.config.systemSize"
        >保存
        </el-button>
      </el-row>
    </el-dialog>
    <el-dialog
      title="修改密码"
      :visible.sync="visible"
      width="50%"
      style="text-align:center;"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <el-form
        :inline="true"
        :model="formData"
        class="demo-ruleForm"
        label-width="100px"
        :rules="formRules"
        ref="formData"
        :size="GLOBAL.config.systemSize"
      >
        <el-row class="margin-top-20">
          <el-col :span="24">
            <el-form-item
              label="账号："
              prop="account"
            >
              <el-input
                v-model="formData.account"
                placeholder="账号"
                disabled
                maxlength="15"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="margin-top-20">
          <el-col :span="24">
            <el-form-item
              label="旧密码："
              prop="oldPwd"
            >
              <el-input
                type="password"
                v-model="formData.oldPwd"
                placeholder="旧密码"
                maxlength="15"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="margin-top-20">
          <el-col :span="24">
            <el-form-item
              label="新密码："
              prop="pwd"
            >
              <el-input
                type="password"
                v-model="formData.pwd"
                placeholder="新密码"
                maxlength="15"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="margin-top-20">
          <el-col :span="24">
            <el-form-item
              label="确认密码："
              prop="pwd2"
            >
              <el-input
                type="password"
                v-model="formData.pwd2"
                placeholder="确认密码"
                maxlength="15"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row class="margin-top-20">
        <el-button
          @click="closeDialog"
          style="margin: 0 20px;"
          :size="GLOBAL.config.systemSize"
        >关闭</el-button>
        <el-button
          type="primary"
          @click="saveAccountAndPwd"
          style="margin: 0 20px;"
          :size="GLOBAL.config.systemSize"
        >保存
        </el-button>
      </el-row>
    </el-dialog>
  </el-container>
</template>
<script>
import functions from './assets/js/functions'
import LockVideoWindow from '@/components/LockVideoWindow'
export default {
  name: 'Index',
  data() {
    let validateOldPassword = (rule, value, callback) => {
        if (!value) {
            callback(new Error('请输入旧密码！'))
        } else if (this.$md5(encodeURIComponent(value)) !== this.userInfo.pwd) {
            callback(new Error('旧密码输入错误！请重新输入'))
        } else {
            callback()
        }
    }
    let validateNewPassword = (rule, value, callback) => {
        if (!value) {
            callback(new Error('请输入新密码！'))
        } else if (value === this.formData.oldPwd) {
            callback(new Error('新密码不能与旧密码相同！'))
        } else {
            callback()
        }
    }
    let validateNew2Password = (rule, value, callback) => {
        if (!value) {
            callback(new Error('请确认新密码！'))
        } else if (value !== this.formData.pwd) {
            callback(new Error('与新密码不一致！'))
        } else {
            callback()
        }
    }
    return {
      show: false,
      warningData: [],
      userInfo: JSON.parse(localStorage.getItem('gcUserInfo')),
      systemName: '肥东县管护平台',
      systemSubName: '',
      footer: 'Copyright © 2019 - 2029 安徽卓新信息科技有限公司 版权所有',
      headPic:
        'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      isCollapse: false,
      // 默认选中菜单
      selectMenu: '',
      value3: 50,
      activeIndex: '/countyControl/index',
      menuList: [], // 菜单集合
      singleList: [], // 只含有一级菜单
      doubleList: [], // 包含二级菜单
      visible: false, // 是否显示
      formData: {
        account: localStorage.getItem('gcUserInfo')
          ? JSON.parse(localStorage.getItem('gcUserInfo')).account
          : '',
        oldPwd: '',
        pwd: '',
        pwd2: ''
      },
      formRules: {
        oldPwd: [
            {required: true, message: '请输入旧密码', trigger: 'blur'},
            { validator: validateOldPassword, trigger: 'blur' }
        ],
        pwd: [
            {required: true, message: '请输入新密码', trigger: 'blur'},
            {pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]+$/, message: '新密码必须包含英文、数字', trigger: 'blur'},
            { min: 6, max: 15, message: '长度在6到15个字符' },
            { validator: validateNewPassword, trigger: 'blur' }
        ],
        pwd2: [
            {required: true, message: '请确认密码', trigger: 'blur'},
            { min: 6, max: 15, message: '长度在6到15个字符' },
            { validator: validateNew2Password, trigger: 'blur' }
        ]
      },
      session: '',
      gpsList: [],
      menuVisible: false,
      allMenu: [], // 数据库所有菜单集合
      defaultProps: {
          children: 'children',
          label: 'name'
      },
      nodesKey: [],
      selectYhlx: ''

    }
  },
  components: {
    LockVideoWindow
  },

  methods: {
    changeindex(val){
      console.log(val)
      if(val==''){
         this.$refs.tree.setCheckedKeys([]);
      }else{
        this.getfindRole(val)
      }

    },
    getfindRole(val){
          let _this = this
          let param = {
              Personnel:{yhqxid:val},
              baseService: 'TGcRoleServiceImpl',
          }
          this.FUNCTIONS.systemFunction.interactiveData(
              _this,
              _this.GLOBAL.config.businessFlag.zxUser,
              'findRole',
              param,
              null,
              resultData => {
                 console.log(resultData)
                 try{
                   let menus=resultData.obj.menus
                   let a=[]
                   menus.forEach(e=>{
                     if (e.url) {
                       a.push(e.menuId)
                     }
                   })
                   console.log(a)
                  _this.$refs.tree.setCheckedKeys(a);
                  _this.nodesKey=a
                 }catch(e){
                   //TODO handle the exception
                 }
              },
              () => {

              }
          )

    },
    nodeClick: function (data, nodes) {
        console.log(nodes)
        this.nodesKey = nodes.checkedKeys.concat(nodes.halfCheckedKeys)
    },
    setMenu: function () {
        this.menuVisible = true
        this.selectYhlx=''
        this.getMenu()
    },
    // 获取所有菜单
    getMenu: function () {
        let _this = this
        let param = {
            current: '1',
            size: '60',
            records: [],
            baseService: 'TGcAppServiceImpl',
        }
        this.FUNCTIONS.systemFunction.interactiveData(
            _this,
            _this.GLOBAL.config.businessFlag.zxUser,
            'getPage',
            param,
            null,
            resultData => {
                _this.loading = false
                if (resultData.code === '200') {
                    console.log(resultData.obj.records)
                    _this.setMenuList(resultData.obj.records)
                } else {
                    _this.$message.warning('获取菜单失败～')
                }
            },
            () => {
                _this.loading = false
            }
        )
    },
    // 菜单重组
    setMenuList: function (menuList) {
        let dList = []
        let sList = []
        menuList.forEach(item => {
            if (!item.icon && item.url) {
                dList.push(item)
            }
            if (!item.url && item.midid) {
                sList.push(item)
            }
        })
        sList.forEach(item => {
            item.children = []
            menuList.forEach(child => {
                if (child.icon == item.midid) {
                    item.children.push(child)
                }
            })
        })
        this.allMenu = dList.concat(sList)
    },
    closeMenuDialog: function () {
        this.menuVisible = false
    },
    saveMenuSelect: function () {
        let _this = this
        // this.menuVisible = false
        console.log(this.$refs.tree.getCheckedNodes());
        console.log(this.$refs.tree.getCheckedKeys());
        if (this.nodesKey.length === 0) {
            this.$message.warning('请勾选菜单！')
            return
        } else if (!this.selectYhlx) {
            this.$message.warning('请选择角色！')
            return
        }
        let param = {
            info: {
                id: this.selectYhlx,
                menuList: this.nodesKey
            },
            baseService: 'TGcRoleServiceImpl',
            type: 'addQx'
        }
        _this.FUNCTIONS.systemFunction.jsonPost(
            _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
            param,
            resultData => {
                _this.loading = false
                if (resultData) {
                    _this.$message.success('菜单设置成功～')
                } else {
                    _this.$message.warning('菜单设置失败～')
                }
            }
        )
    },
    init: function () {
      return null
    },
    getInfo: function () {
      return null
    },
    // 菜单选择
    menuSelect: function (target) {
      if (localStorage.getItem('gcUserInfo')) {
        let code = JSON.parse(localStorage.getItem('gcUserInfo')).ssqhdm
        // 县级用户
        if (code % 1000000 === 0) {
          this.$router.push({ path: target })
        } else {
          if (
            target == '/villagesBCStatistics' ||
            target == '/villagesBXStatistics'
          ) {
            // 报抽
            if (target == '/villagesBCStatistics') {
              this.$router.push({
                // path: '/villagesBCStatistics/townsBCStatistics/',
                name: 'TownsBCStatistics',
                params: {
                  villageCode: code
                }
              })
            } else {
              // 报修
              this.$router.push({
                // path: '/villagesBCStatistics/townPeopleBCStatistics',
                name: 'TownsBXStatistics',
                params: {
                  villageCode: code
                }
              })
            }
          } else {
            this.$router.push({ path: target })
          }
        }
      } else {
        this.$message({
            type: 'warning',
            message: '请登录后进行查看！',
            duration:800,
        })
        this.$router.push({ path: '/' })
      }
    },
    // 退出系统
    exitSystem: function () {
      let _this = this
      _this
        .$confirm('确认退出系统？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          // 清除前端缓存
          const menuList = localStorage.getItem('menuList')
          localStorage.clear()
          // localStorage.setItem('menuList', menuList)
          sessionStorage.clear()
          this.$router.push('/')
          window.location.reload()
          // _this.FUNCTIONS.systemFunction.commonGet(
          //   _this.CONFIG.urls.root + _this.CONFIG.urls.index.logout,
          //   result => {
          //     if (result.code === '0') {
          //       // 清除前端缓存
          //       localStorage.clear()
          //       sessionStorage.clear()
          //       window.location.href = result.data
          //     } else {
          //       this.$message({
          //         message: '退出异常～请联系管理员',
          //         type: 'error'
          //       })
          //     }
          //   }
          // )
        })
    },
    changeAccountAndPwd() {
      this.visible = true
    },
    // 保存账号密码
    saveAccountAndPwd() {
      let _this = this
      let param = {}
      param.baseService = 'TGcUserServiceImpl'
      param.account = this.formData.account
      param.pwd = this.$md5(encodeURIComponent(this.formData.pwd))
      this.$refs.formData.validate(valid => {
        if (valid) {
          _this.FUNCTIONS.systemFunction.interactiveData(
            _this,
            _this.GLOBAL.config.businessFlag.zxUser,
            'updateCurrentUser',
            param,
            null,
            resultData => {
              _this.loading = false
              if (resultData) {
                _this.$message.success('修改成功，请重新登录')
                localStorage.clear()
                sessionStorage.clear()
                window.location.reload()
              } else {
                _this.$message.warning('修改密码失败～')
              }
            },
            () => {
              _this.loading = false
            }
          )
        }
      })
    },
    closeDialog() {
      this.visible = false
    },
    getUserInfo: function () {
      function g() {
        if (JSON.parse(unescape(localStorage.getItem('userInfo')))) {
          return '--'
        }
      }

      return localStorage.getItem('userInfo') ? g() : '--'
    }
  },
  created() {
    // 获取用户菜单
    function recursion(list) {
      let mapList = list.map(item => {
        let temp = {
          name: item.name,
          url: item.url,
          icon: item.icon,
          code: item.code
        }
        if (item.children) {
          temp.children = recursion(item.children)
        }
        return temp
      })
      return mapList
    }
    // this.menuList = recursion(this.CONFIG.tempMenu)
    let _this = this
    // this.menuList.forEach(item => {
    //   if (item.children) {
    //     _this.doubleList.push(item)
    //   } else {
    //     _this.singleList.push(item)
    //   }
    // })
    // this.$router.push('/countyControl/index')
    // 重组菜单
    let tempList = JSON.parse(localStorage.getItem('menuList'))
    tempList.forEach(item => {
      if (!item.icon && item.url) {
        _this.singleList.push(item)
      }
      if (!item.url && item.midid) {
        _this.doubleList.push(item)
      }
    })
    this.doubleList.sort(function (a, b) {
        return a.menuId - b.menuId
    })
    this.doubleList.forEach(item => {
      item.children = []
      tempList.forEach(child => {
        if (child.icon == item.midid) {
          item.children.push(child)
        }
      })
    })
    this.doubleList.forEach(item => {
        if (item.midid === '2') {
            item.children.sort(function (a, b) {
                return a.menuId - b.menuId
            })
        }
        if (item.midid === '6') {
            item.children.sort(function (a, b) {
              return a.menuId - b.menuId
            })
        }
    })
    let userInfo = JSON.parse(localStorage.getItem('gcUserInfo'))
    if (userInfo.yhlx === '3' && userInfo.account === 'ceshi02') {
        this.doubleList.forEach(item => {
            if (item.midid === '5') {
                item.children.push({
                    name: '操作日志',
                    url: '/logManagement'
                })
            }
        })
    }
    console.log(this.doubleList)
    this.$router.push('/countyControl/index')
  }
}
</script>
<style scoped lang="scss">
.dis-flex {
  display: flex;
}
.js-center {
  justify-content: center;
}
.head {
  top: 0;
  left: 0;
  /*z-index: 19;*/
  font-family: SimHei;
}
.wp-100 {
  width: 100%;
}
.js-between {
  justify-content: space-between;
}
.align-center {
  align-items: center;
}
.menu-list {
  text-align: center;
  color: #333333;
  font-size: 16px;
}
.index-login {
  width: 400px;
  height: 145px;
}
.index-img {
  width: 800px;
  height: 145px;
}
.main-width {
  width: 1200px;
}

.account-space {
  cursor: pointer;
  color: #2b68e4;
}

/deep/ .el-dialog__title {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/Index.vue